import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import http from 'axios'
import { Button, Icon, Slider } from '@mui/material'
import { formatHoursMinutes } from 'core/lib'

import './styles.css'

function AvailableHoursList({ service, selectedDay }) {
	const dispatch = useDispatch()
	const cartProducts = useSelector(state => state.cart.products)

	//? The service goes 1 to 7 and the calendar goes 1 to 6
	const day = moment(selectedDay).day() == 0 ? 7 : moment(selectedDay).day() // get the number of the day [1, 2, 3, 4, 5, 6 or 7]

	// to load reservations that was already reserved
	const [reservations, setReservations] = useState([])

	const [itemReservation, setItemReservation] = useState(null)
	const [startReservationHour, setStartReservationHour] = useState('')
	const [endReservationHour, setEndReservationHour] = useState('')
	const [resourceSelected, setResourceSelected] = useState(null)
	const [counterClick, setCounterClick] = useState(0)

	const [timePeriod, setTimePeriod] = useState(null)
	const [seatsToBooking, setSeatsToBooking] = useState(1)
	const [price, setPrice] = useState(0)

	const handleLoadReservations = async() => {
		const reservationDate = moment(selectedDay).format('YYYYMMDD')
		const loadReservations = await http.get(`${window.__endpoint}/api/booking/dayAvailability?item_id=${service.item_id}&date=${reservationDate}`)

		// Aggiungo le risorse già impegnate dalle prenotazioni che ho nel carrello
		if (service.res_type == 1) {
			Object.values(loadReservations.resources).forEach(resource => {
				const cartReservation = cartProducts.filter(p => String(p.key).slice(0, 12) == 'reservation_').filter(p => resource.resource_id == p.resource_id)
				return {
					...resource,
					hours: resource.hours.map(hour => {
						cartReservation.forEach(reservation => {
							if (moment(reservation.reservation_day).format('YYYYMMDD') == moment(selectedDay).format('YYYYMMDD') && moment(hour.start, 'HH:mm').isSameOrAfter(moment(reservation.start, 'HH:mm')) && moment(hour.end, 'HH:mm').isSameOrBefore(moment(reservation.end, 'HH:mm'))) {
								hour.available = false
							}
						})
						return hour
					})
				}
			})
		} else {
			loadReservations.hours = loadReservations.hours.map(hour => {
				const cartReservation = cartProducts.filter(p => String(p.key).slice(0, 12) == 'reservation_').filter(p => service.item_id == p.item_id)
				let available = true
				cartReservation.forEach(reservation => {
					if (moment(reservation.reservation_day).format('YYYYMMDD') == moment(selectedDay).format('YYYYMMDD') && moment(hour.start, 'HH:mm').isSameOrAfter(moment(reservation.start, 'HH:mm')) && moment(hour.end, 'HH:mm').isSameOrBefore(moment(reservation.end, 'HH:mm'))) {
						available = false
					}
				})
				return {
					...hour,
					available: available,
				}
			})
		}

		setReservations(loadReservations)
	}

	useEffect(() => {
		// Load reservations hours
		handleLoadReservations()

		// Set new reservations data
		resetReservation()
	}, [selectedDay])

	useEffect(() => {
		// Load reservations hours
		handleLoadReservations()
	}, [cartProducts])

	useEffect(() => {
		setPrice(getPrice('sal_price_with_tax'))
	}, [startReservationHour, endReservationHour])

	const resetReservation = () => {
		setStartReservationHour('')
		setEndReservationHour('')
		setResourceSelected(null)
		setItemReservation(null)
		setSeatsToBooking(1)
	}

	const handleAlreadyReserved = (interval, resource_id) => {
		let isAvailable = false
		let numSeatsAlreadyReserved = 0

		if (service.res_type == '1') {
			reservations.resources != undefined && Object.entries(reservations.resources).map(([key, value]) => {
				if (Number(value.resource_id) == Number(resource_id)) {
					value.hours.forEach((hr) => {
						if (moment(interval, 'HH:mm').isSameOrAfter(moment(hr.start, 'HH:mm')) && moment(interval, 'HH:mm').isBefore(moment(hr.end, 'HH:mm'))) {
							isAvailable = !hr.available // hour interval reserve
						}
					})
				}
			})
		}

		if (service.res_type == '2') {
			reservations.hours != undefined && reservations.hours.map((hr) => {
				if (moment(interval, 'HH:mm').isSameOrAfter(moment(hr.start, 'HH:mm')) && moment(interval, 'HH:mm').isBefore(moment(hr.end, 'HH:mm'))) {
					isAvailable = !hr.available // hour interval reserve
					numSeatsAlreadyReserved = numSeatsAlreadyReserved + Number(hr.available_seats) // number of seats that was already reserved in this period
				}
			})
		}

		return [isAvailable, numSeatsAlreadyReserved]
	}

	const handleAlreadyReserved2 = (interval) => {
		let isAvailable = false
		let numSeatsAlreadyReserved = 0

		if (service.res_type == '2') {
			reservations.hours != undefined && reservations.hours.map((hr) => {
				if (moment(interval, 'HH:mm').isSameOrAfter(moment(hr.start, 'HH:mm')) && moment(interval, 'HH:mm').isBefore(moment(hr.end, 'HH:mm'))) {
					isAvailable = !hr.available // hour interval reserve
				}
			})
		}

		return [isAvailable, numSeatsAlreadyReserved]
	}

	const handleReservationSelectedInterval = (start, end, resource_id, item_id, time_period) => {
		// if change resource, set new values
		if (resourceSelected != resource_id) {
			setStartReservationHour(start)
			setEndReservationHour(end)
			setResourceSelected(resource_id)
			setItemReservation(item_id)
			setTimePeriod(time_period)
		}

		if (resourceSelected == resource_id && timePeriod != time_period) {
			setStartReservationHour(start)
			setEndReservationHour(end)
			setResourceSelected(resource_id)
			setItemReservation(item_id)
			setTimePeriod(time_period)
		}

		// Se seleziono un orario prima di quello gia selezionato
		if (moment(start, 'HH:mm').isSameOrBefore(moment(startReservationHour, 'HH:mm')) && timePeriod == time_period) {
			reservations.resources[resource_id].hours.forEach(res => {
				if (reservations.resources[resource_id].hours > 0) {
					if (moment(start, 'HH:mm').isBefore(moment(res.start, 'HH:mm')) && res.available == 'true') {
						setEndReservationHour(end)
					}
				}
				else {
					setStartReservationHour(start)
				}
			})
		}

		// Se l'orario che seleziono vieni dopo quello gia selezionato
		if (moment(start, 'HH:mm').isSameOrAfter(moment(endReservationHour, 'HH:mm')) && timePeriod == time_period){
			reservations.resources[resource_id].hours.forEach(res => {
				if (reservations.resources[resource_id].hours > 0) {
					if (moment(start, 'HH:mm').isBefore(moment(res.start, 'HH:mm')) && res.available == 'true') {
						setEndReservationHour(end)
					}
				}
				else {
					setEndReservationHour(end)
				}
			})
		}

		// Se l'orario selezionato e' dentro all'intervalo gia impostato
		if (moment(start, 'HH:mm').isSameOrAfter(moment(startReservationHour, 'HH:mm')) && moment(end, 'HH:mm').isSameOrBefore(moment(endReservationHour, 'HH:mm'))) {
			setStartReservationHour('')
			setEndReservationHour('')
			setResourceSelected(null)
			setItemReservation(null)
			setSeatsToBooking(1)
		}
	}

	const handleCreateIntervals = (resource_id, hours, step_time) => {
		var i = hours.start
		var intervals = []

		// creating the invervals array
		while (i != hours.end) {
			intervals.push(i)

			// Increase min_step o duration
			i = moment(i, 'HH:mm:ss').add(step_time, 'minutes').format('HH:mm:ss')
		}
		intervals.push(hours.end)

		return intervals
	}

	const handleReservationSelectedTime = (start, end, item_id) => {
		if (counterClick == 0) {
			reservations.hours.forEach(res => {
				if (res.start == start && res.available == true) {
					setStartReservationHour(start)
					setEndReservationHour(end)
					setCounterClick(counterClick + 1)
					setItemReservation(item_id)
				}
			})
		}
		else if (counterClick == 1 && start != startReservationHour) {
			reservations.hours.forEach(res => {
				if (res.start == start && res.available == true) {
					setStartReservationHour(start)
					setEndReservationHour(end)
					setItemReservation(item_id)
				}
			})
		}
		else if (counterClick == 1 && start == startReservationHour) {
			setStartReservationHour('')
			setEndReservationHour('')
			setCounterClick(0)
		}
	}

	const handleSliderChange = (event, newValue) => {
		setSeatsToBooking(newValue)
	}

	const handleCalculateAvailableSeats = () => {
		let seatsAlreadyBooked = 0
		reservations.hours.map(res => {
			if (res.start == startReservationHour && res.end == endReservationHour) {
				seatsAlreadyBooked = res.available_seats
			}
		})

		return seatsAlreadyBooked
	}

	const getPrice = (type) => {
		let price = 0
		const reservedMinutes = moment(endReservationHour, 'HH:mm').diff(moment(startReservationHour, 'HH:mm'), 'minutes')
		if (reservedMinutes > 0) {
			if (service.res_type == '1') {
				price = service[type] / 60 * moment(endReservationHour, 'HH:mm').diff(moment(startReservationHour, 'HH:mm'), 'minutes')
			}

			if (service.res_type == '2') {
				price = service[type]
			}
		}

		return Number(price)
	}

	const addToCart = () => {
		// Get max res from products keys or 0
		const maxKey = Math.max.apply(Math, cartProducts.map(o => {
			if (String(o.key).slice(0, 12) == 'reservation_') {
				return o.key.split('_')[1]
			} else {
				return 0
			}
		}))
		const newKey = maxKey > 0 ? maxKey + 1 : 1

		let lineName = service.name
		if (service.res_type == '1') {
			lineName += ` ${service.resources.find(res => res.resource_id == resourceSelected).name}`
		}

		const cartProduct = {
			key: `reservation_${newKey}`,
			name: lineName,
			description: `Il giorno ${moment(selectedDay).format('DD/MM/YYYY')} dalle ${formatHoursMinutes(startReservationHour)} alle ${formatHoursMinutes(endReservationHour)}`,
			resource_name: service.name,
			resource_id: resourceSelected ? resourceSelected : null,
			item_id: itemReservation,
			reservation_day: moment(selectedDay).format('YYYY-MM-DD'),
			start: startReservationHour,
			end: endReservationHour,
			seats: seatsToBooking ? seatsToBooking : 1,
			sal_price: getPrice('sal_price'),
			tax_id: service.tax_id,
			price: price,
		}
		dispatch({ type: 'addProduct@cart', product: cartProduct, quantity: 1, availableQuantity: null })
		dispatch({ type: 'setFeedback@ui', message: 'Prodotto aggiunto al carrello' })

		resetReservation()
	}

	return (
		<div style={{ marginBottom: 20 }}>
			{/* Mostrare risorse */}
			{service.res_type == '1' && service.resources.map((resource, id) => (
				<div key={resource.resource_id}>
					<div style={{ display: 'flex', marginTop: 20 }}>
						<span style={{ marginRight: 20, color: 'var(--black)' }}><strong style={{ textDecoration: 'underline' }}>{resource.name}</strong></span>
					</div>

					{service.availability[day] ?
						Object.entries(service.availability).map(([key, value]) => (<div key={key}>
							{String(key) == String(day) && <React.Fragment>
								{value.hours.map((hours, idxHours) => {
									const intervals = handleCreateIntervals(resource.resource_id, hours, service.min_step ? service.min_step : service.duration)

									return (<div key={idxHours}>
										<div className='square-container'>

											{intervals.map((interval, idxInterval, a) => (
												idxInterval < intervals.length - 1 ?
													<div key={idxInterval} style={{ display: 'flex', flexDirection: 'column' }}>
														{/* Square */}
														<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
															<div className='square-divider' />

															{handleAlreadyReserved(interval, resource.resource_id)[0] ?
																// Orario e tutti i posti riservarti
																<div style={{ width: 80, height: 40, background: '#EC4758', borderRadius: 4, margin: '2px 2px' }} />
																:
																(interval >= startReservationHour && interval < endReservationHour && resource.resource_id == resourceSelected)
																	?
																	<div style={{ width: 80, height: 40, background: '#1c84c6', borderRadius: 4, margin: '2px 2px' }} onClick={() => handleReservationSelectedInterval(a[idxInterval], a[idxInterval + 1], resource.resource_id, resource.item_id)} />
																	:
																	<div
																		style={{ width: 80, height: 40, background: '#1AB394', borderRadius: 4, margin: '2px 2px' }}
																		onClick={() => handleReservationSelectedInterval(a[idxInterval], a[idxInterval + 1], resource.resource_id, service.item_id, idxHours)}
																	/>
															}
														</div>

														{/* Time */}
														{idxInterval == 0
															? <span style={{ fontSize: 12, marginTop: 2, marginBottom: 10, fontWeight: 'bold', position: 'relative' }}>{moment(intervals[idxInterval], 'HH:mm').format('HH:mm')}</span>
															: <span style={{ fontSize: 12, marginTop: 2, marginBottom: 10, marginLeft: -14, fontWeight: 'bold', position: 'relative' }}>{moment(intervals[idxInterval], 'HH:mm').format('HH:mm')}</span>}
													</div>
													:
													<div key={idxInterval}>
														<div style={{ height: 40, width: 1, borderRight: '2px solid #bbbdbe', marginLeft: 1, marginTop: -7 }} />
														<span style={{ fontSize: 12, marginTop: 2, marginBottom: 10, marginLeft: -26, fontWeight: 'bold', position: 'relative' }}>{moment(intervals[idxInterval], 'HH:mm').format('HH:mm')}</span>
													</div>
											))}
										</div>
									</div>)
								})}
							</React.Fragment>}
						</div>)) :
						<p>Nessuna disponibilità in questa giornata</p>
					}
				</div>
			))}

			{service.res_type == '2' && <React.Fragment>
				{service.availability[day] ? Object.entries(service.availability).map(([key, value]) => (
					<div key={key}>

						{String(key) == String(day) &&
						<React.Fragment>
							<div style={{ display: 'flex', marginTop: 20 }}>
								<span style={{ marginRight: 20, color: 'var(--black)' }}><strong style={{ textDecoration: 'underline' }}>{service.name}</strong></span>
							</div>

							{value.hours.map((hours, idxHours) => {
								const intervals = handleCreateIntervals(service.resource_id, hours, service.min_step ? service.min_step : service.duration)

								return (
									<React.Fragment key={idxHours}>
										<div key={idxHours} className="square-container">
											{intervals.map((interval, idxInterval, a) => (
												idxInterval < intervals.length - 1 ?
													<div key={idxInterval} style={{ display: 'flex', flexDirection: 'column' }}>
														{/* Square */}
														<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
															<div className="square-divider" />

															{handleAlreadyReserved2(interval)[0] ?
																<div style={{ width: 80, height: 40, background: '#F08080', borderRadius: 4, margin: '2px 2px' }} />
																:
																(interval >= startReservationHour && interval < endReservationHour) ?
																	<div
																		style={{ width: 80, height: 40, background: '#4f67e0', borderRadius: 4, margin: '2px 2px' }}
																		onClick={() => handleReservationSelectedTime(a[idxInterval], a[idxInterval + 1], service.item_id)}
																	/>
																	:
																	<div
																		style={{ width: 80, height: 40, background: '#a1df90', borderRadius: 4, margin: '2px 2px' }}
																		onClick={() => handleReservationSelectedTime(a[idxInterval], a[idxInterval + 1], service.item_id)}
																	/>
															}
														</div>
														{/* Time */}
														{idxInterval == 0
															? <span style={{ fontSize: 12, marginTop: 2, marginBottom: 10, fontWeight: 'bold', position: 'relative' }}>{moment(intervals[idxInterval], 'HH:mm').format('HH:mm')}</span>
															: <span style={{ fontSize: 12, marginTop: 2, marginBottom: 10, marginLeft: -14, fontWeight: 'bold', position: 'relative' }}>{moment(intervals[idxInterval], 'HH:mm').format('HH:mm')}</span>}
													</div>
													:
													<div key={idxInterval}>
														<div style={{ height: 40, width: 1, borderRight: '2px solid #bbbdbe', marginLeft: 1, marginTop: -7 }} />
														<span style={{ fontSize: 12, marginTop: 2, marginBottom: 10, marginLeft: -26, fontWeight: 'bold', position: 'relative' }}>{moment(intervals[idxInterval], 'HH:mm').format('HH:mm')}</span>
													</div>
											))}
										</div>
									</React.Fragment>
								)
							})}

							{/* Solo se ha la possibilita di selezionare il numero di posti */}
							{service.input_seats_flag == '1' && startReservationHour != '' &&
								<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>

									<span>Posti disponibili: <strong>{handleCalculateAvailableSeats()}</strong> </span>

									<Slider
										aria-label="Posti disponibili"
										defaultValue={1}
										valueLabelDisplay="auto"
										onChange={handleSliderChange}
										marks
										step={1}
										min={1}
										max={handleCalculateAvailableSeats()}
									/>

									<div>
										<span>Posti da prenotare? </span>
										<strong>{seatsToBooking} </strong>
									</div>
								</div>
							}
						</React.Fragment>
						}
					</div>
				)) : <p>Nessuna disponibilità in questa giornata</p>}
			</React.Fragment>}

			{service.availability[day] && <p style={{ textAlign: 'center' }}>
				{service.res_type == '1' ? <small>Seleziona l'orario di inizio e fine della tua prenotazione</small> : <small>Seleziona l'orario della tua prenotazione</small>}<br/>
				{price > 0 && <small>Costo della prenotazione: <strong>{price.toFixed(2)} €</strong></small>}
			</p>}
			<div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
				<Button disabled={startReservationHour == ''} color="primary" variant="contained" onClick={addToCart}><Icon>add_shopping_cart</Icon></Button>
			</div>
		</div>
	)
}

export default AvailableHoursList
